import Multiselect from 'vue-multiselect';

//

var script = {
  name: 'PtSelect',
  components: { Multiselect: Multiselect },
  props: {
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    internalSearch: {
      type: Boolean,
      default: true,
    },
    labelKey: {
      type: String,
      default: null,
      description: 'Label from option Object that will be visible in the dropdown.',
    },
    loader: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select Option',
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select',
    },
    selectedLabel: {
      type: String,
      default: 'Selected',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    tagPlaceholder: {
      type: String,
      default: 'Press enter to create a tag',
    },
    trackBy: {
      type: String,
      default: null,
      description: 'Unique key to track each option like :key',
    },
    value: {
      type: [Object, Array, String, Number],
      default: null,
    },
  },
  data: function data() {
    return {
      selected: null,
    };
  },
  watch: {
    value: function value(newVal) {
      this.setValue(newVal, null, false);
    },
  },
  mounted: function mounted() {
    this.setValue(this.value, null, false);
  },
  methods: {
    handleSearch: function handleSearch(term) {
      this.$emit('search-change', term);
    },
    handleTag: function handleTag(term) {
      this.$emit('tag', term);
    },
    setValue: function setValue(option, id, emit) {
      if ( id === void 0 ) id = null;
      if ( emit === void 0 ) emit = true;

      this.selected = option;

      if (emit) {
        this.$emit('input', option);
        this.$emit('select', option);
      }
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("multiselect", {
    attrs: {
      "allow-empty": _vm.allowEmpty,
      "deselect-label": _vm.deselectLabel,
      disabled: _vm.disabled,
      "internal-search": _vm.internalSearch,
      label: _vm.labelKey,
      loading: _vm.loader,
      multiple: _vm.multiple,
      options: _vm.options,
      placeholder: _vm.placeholder,
      searchable: _vm.searchable,
      "select-label": _vm.selectLabel,
      "selected-label": _vm.selectedLabel,
      "show-labels": _vm.showLabels,
      taggable: _vm.multiple,
      "tag-placeholder": _vm.tagPlaceholder,
      "track-by": _vm.trackBy,
      value: _vm.selected
    },
    on: {
      input: _vm.setValue,
      "search-change": _vm.handleSearch,
      tag: _vm.handleTag
    },
    scopedSlots: _vm._u([
      {
        key: "singleLabel",
        fn: function(props) {
          return [
            _vm._t(
              "selectedOption",
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.labelKey ? props.option[_vm.labelKey] : props.option
                    ) +
                    "\n      "
                )
              ],
              { option: props.option }
            )
          ]
        }
      },
      {
        key: "option",
        fn: function(props) {
          return [
            _vm._t(
              "option",
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.labelKey ? props.option[_vm.labelKey] : props.option
                    )
                  )
                ])
              ],
              { option: props.option, search: props.search }
            )
          ]
        }
      }
    ])
  })
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Select = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Select as PtSelect };
